import { toast } from 'react-toastify';
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { addOneAnnouncementToStore } from 'store/actions/announcement';
import { Button } from 'app/shared/button';
import { SimpleInput } from 'app/shared/input';
import { useAnnouncementService } from 'hooks/api/iam/announcement';
import { ImageUploadField } from '../image-upload';

const UpdateAnnouncement = ({ announcement, closeModal = () => {} }) => {
  const dispatch = useDispatch();
  const { updateAnnouncement } = useAnnouncementService();

  const [image_url, setImageUrl] = useState('');
  const [url, setUrl] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!announcement) return;
    setImageUrl(announcement.image_url || '');
    setUrl(announcement.url || '');
  }, [announcement]);

  const submit = async () => {
    if (!image_url) {
      toast.error('Image URL is required.');
      return;
    }

    const data = { image_url, url: url || null };

    setLoading(true);
    const result = await updateAnnouncement(announcement.id, data);
    setLoading(false);

    if (!result) return;

    dispatch(addOneAnnouncementToStore({ ...announcement, ...data }));
    closeModal();
  };

  return (
    <div>
      <ImageUploadField value={image_url} onChange={setImageUrl} />
      <SimpleInput
        label="Target URL"
        placeholder="https://example.com"
        value={url}
        onInput={setUrl}
      />
      <Button
        icon_name="add"
        text="Update"
        onClick={submit}
        className="float-right w-25 mt-4 mb-4"
        loading={loading}
      />
      <Button
        text="Cancel"
        type="secondary"
        onClick={closeModal}
        className="float-right w-25 mt-4 mb-4 mr-4"
        loading={loading}
      />
    </div>
  );
};

export default UpdateAnnouncement;
